<template>
  <div>
    <h2>THE HIBISCUS COLLECTION - LAUNCHING SOON</h2>
    <p>
      Keep an eye on your inbox, we'll let you know as soon as you can enjoy
      early collection access.
    </p>
    <Countdown :end="endDate" class="countdown" />

    <Button
      tag="a"
      theme="primary-light"
      href="/pages/hibiscus-the-look-book"
      class="wishlist-button"
    >
      Browse the lookbook
    </Button>
  </div>
</template>

<script>
import Button from "@/components/ButtonV3.vue";
import Countdown from "@/components/landing/Countdown.vue";

export default {
  name: "LandingSuccess",
  components: {
    Countdown,
    Button,
  },
  props: {
    endDate: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
h2 {
  @include editorial-headline(24px);
  text-transform: uppercase;
  margin-bottom: 16px;
}

p {
  @include editorial-body(14px);
  margin-bottom: 28px;
}

.countdown {
  margin-bottom: 28px;
}

.wishlist-button {
  display: inline-block;
}
</style>
